export default "__VITE_ASSET__b8f292c1__"